import React from "react";
import '../index.css';
import  web from '../Images/c1.jpeg';


import  web1 from '../Images/c17.jpeg';
import five from '../Images/c2.jpeg';

import Common from './Common';
// import Regional from "./Regional";
// import Testing from "./Testing";

const Home = () => {
  return (
    <>
    <Common name="An International Pandemic" name1="Coronavirus disease"  imgsrc={web} visit="/about" btnname="Get Started"/>

    <div className="container-fluid ">

<img src={web1} className="img-fluid mx-auto d-block" alt="covid"/>
    </div>
    <section id="header" className="d-flex align-items-center mb-5">
      <div className="container-fluid nav_bg">
        <div className="row">
          <div className="col-10 mx-auto">
          <div className="row">
            <div className="col-lg-6 pt-3 pt-lg-5 order-1 order-lg-2 d-flex justify-content-center flex-column text-center">
              
              <h1><strong className="brand-name text-center">Protect yourself and others from COVID-19</strong> </h1>
        <button className="btn btn-sm m-5" id="b"><a href="https://vipashaav321.github.io/COVID19-Tracker-2.0/">Check Visual Data Representation</a></button> 
              <div className="mt-3">
              </div>
            </div>
            <div class="col-lg-6 order-2 order-lg-1 header-img">
              <img src={five} className="img-fluid animated" alt="home-img"/>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   
{/* <img src="https://i.pinimg.com/474x/f6/bf/2e/f6bf2e04758dda78585bf9f9ec9feb34.jpg" className="img-fluid mx-auto d-block" alt="covid"/> */}

{/* <Testing/> */}

      
    </>
  );
};

export default Home;
